module.exports = __webpack_public_path__ + "assets/img/10.a89215fa.png";